<template>
  <div class="defectiveGoods">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.ReportsDetail.DEFECTS_DISPOSAL') }}
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Defective_Product_Area') }}</span>
      <div class="img">
        <show-img
          :data="defectiveGoods.defectarea"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in defectiveGoods.defectarea"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{
        $tc('lang.ReportsDetail.Vendor_Representative_Confirmed')
      }}</span>
      <div class="img">
        <show-img
          :data="defectiveGoods.groupphoto"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.QC_Confirmed') }}</span>
      <div class="img">
        <show-img
          :data="defectiveGoods.qcgroupphoto"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.replace') }}</span>
      <div class="img">
        <show-img
          :data="defectiveGoods.replace"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Untreated') }}</span>
      <div class="img">
        <show-img
          :data="defectiveGoods.Untreated"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in defectiveGoods.cancel"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Rework') }}</span>
      <div class="img">
        <show-img
          :data="defectiveGoods.rework"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in defectiveGoods.rework"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>
    <div class="desOfGoods-table">
      <a-table
        class="desOfGoods-table1"
        :columns="columns"
        :dataSource="data"
        bordered
        :pagination="false"
        rowKey="id"
      >
      </a-table>
    </div>
  </div>
</template>
<script>
// const data = [
//   {
//     street: 12,
//     street7: 23112,
//     street1: 321,
//     street2: 312,
//     street3: 312,
//     street4: 312,
//     street5: 312,
//   },
// ];
import showImg from './showImg';
export default {
  data() {
    return {
      columns: [
        {
          title: this.$tc('lang.ReportsDetail.Nr'),
          fixed: 'left',
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: this.$tc('lang.ReportsDetail.DefectDescription'),
          dataIndex: 'defectDesc',
          key: 'defectDesc',
        },
        {
          title: this.$tc('lang.ReportsDetail.Data_records'),
          children: [
            {
              title: this.$tc('lang.ReportsDetail.DefectQuantity'),
              dataIndex: 'defectCount',
              key: 'defectCount',
            },
            {
              title: this.$tc('lang.ReportsDetail.rework'),
              dataIndex: 'defectRework',
              key: 'defectRework',
            },
            {
              title: this.$tc('lang.ReportsDetail.replace'),
              dataIndex: 'defectReplace',
              key: 'defectReplace',
            },
            {
              title: this.$tc('lang.ReportsDetail.Untreated'),
              dataIndex: 'defectCancel',
              key: 'defectCancel',
            },
          ],
        },
      ],
      data: [],
    };
  },
  components: {
    showImg,
  },
  computed: {
    details: {
      get() {
        return JSON.parse(JSON.stringify(this.$store.state.report.details));
      },
    },
    defectiveGoods: {
      get() {
        return this.$store.state.report.imgList.defectiveGoods;
      },
    },
  },
  created() {
    this.getSelectDate();
  },
  methods: {
    getSelectDate() {
      this.$http
        .post('/hzwmj/inspect-defect/selectDate', {
          orderNo: this.details.orderId,
          reportNo: this.details.ireportId,
        })
        .then(data => {
          if (data) {
            this.data = [];
            data.data.forEach(item => {
              this.data.push(item.defect);
            });
            // this.data = data;
          } else {
            this.data = [];
          }
        })
        .catch(() => {
          this.data = [];
        });
    },
  },
};
</script>
<style lang="less">
.defectiveGoods {
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      text-align: left;
      display: inline-block;
      width: 200px;
      flex-shrink: 0;
      padding-left: 20px;
      // text-align: center;
    }
    // img {
    //   width: 20%;
    //   height: 150px;
    //   margin: 0 20px 20px;
    // }
  }
  .desOfGoods-table {
    display: flex;
    .desOfGoods-table1 {
      flex-grow: 1;
      margin-left: 20px;
      .ant-table-footer {
        padding: 0;
        .footer1 {
          border-right: 1px solid #e8e8e8;
          width: 30%;
        }
        p {
          display: inline-block;
          padding: 0 16px;
          margin-bottom: 0;
          line-height: 52px;
        }
      }
    }
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
  }
}
</style>
